import { Component, inject, Input } from '@angular/core';

import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-logo',
  standalone: true,
  template: `<img
    [src]="isDark() ? 'assets/img/dreampay-logo-dark.svg' : 'assets/img/dreampay-logo.svg'"
    alt="DreamPay"
    [style.height]="heightMap[size]"
    style="width: auto"
  />`,
})
export class LogoComponent {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  private readonly themeService = inject(ThemeService);

  readonly heightMap = {
    sm: '16px',
    md: '22px',
    lg: '32px',
  };

  isDark(): boolean {
    return document.documentElement.classList.contains('dark');
  }
}
